
import { storyblokInit } from "@storyblok/react";
import { apiPlugin } from "@storyblok/react";
import AttackSurfaceManagement from "@/components/AttackSurfaceManagement";
import Page from "@/components/Page";
import AppBar from "@/components/AppBar/Appbar";
import global_reference from "@/components/global_reference/Footer";
import HomePage from "@/components/HomePage/HomePage";
import VulnerabilityManagement from "@/components/VulnerebilityManagement/VulnerabilityManagement";
import PenetrationTesting from "@/components/PenetrationTesting/PenetrationTesting";
import VulnerabilityIntelligence from "@/components/VulnerabilityIntelligence/VulnerabilityIntelligence";
import ContinousAttackSurfaceReduction from "@/components/useCasePages/ContinousAttackSurfaceReduction/ContinousAttackSurfaceReduction";
import NetworkApplicationVulnerabilityManagement from "@/components/useCasePages/NetworkApplicationVulnerabilityManagement/NetworkApplicationVulnerabilityManagement";
import VulnerabilityPrioritization from "@/components/useCasePages/VulnerabilityPrioritization/VulnerabilityPrioritization";
import NetworkInfrastructurePenetrationTesting from "@/components/useCasePages/NetworkInfrastructurePenetrationTesting/NetworkInfrastructurePenetrationTesting";
import MeetYourComplianceRequirements from "@/components/useCasePages/MeetYourComplianceRequirements/MeetYourComplianceRequirements";
import AssetsWithKnownRansomwareExploitableVulnerabilities from "@/components/useCasePages/AssetsWithKnownRansomwareExploitableVulnerabilities/AssetsWithKnownRansomwareExploitableVulnerabilities";
import AboutUs from "@/components/AboutUs/AboutUs";
import PartnerPage from "@/components/PartnerPage/PartnerPage";
import MediaPage from "@/components/MediaPage/MediaPage";
import ReportsPage from "@/components/ReportsPage/ReportsPage";
import RansomwareReport from "@/components/RansomwareReport/RansomwareReport";
import CybersecurityState from "@/components/CybersecurityState/CybersecurityState";
import ConnectPage from "@/components/ConnectPage/ConnectPage";
import ArticlesPage from "@/components/ArticlesPage/ArticlesPage";
import Careers from "@/components/Careers/Careers";
import PrivacyPolicy from "@/components/PrivacyPolicy/PrivacyPolicy";
import CustomerAgreements from "@/components/CustomerAgreements/CustomerAgreements";
import Cookies from "@/components/Cookies";
import Report from "@/components/Report";
import NotFoundPage from "@/app/not-found";
import ComingSoon from "@/components/CommingSoon";
import ZeroDays from "@/components/ZeroDays";
import { ZeroDaysHero } from "@/components/ZeroDaysHero";
import { ZeroDaysTable } from "@/components/ZeroDaysTable";
import { Timeline } from "@/components/HorizontalTimeline/Timeline";
import ZeroDaysFooterCTA from "@/components/ZeroDaysFooterCTA";
import ZeroDaysContent from "@/components/ZeroDaysContent";
import DiscoverZeroDays from "@/components/DiscoverZeroDays";
import Patent from "@/components/Patent";
import VulnerabilityNotices from "@/components/VulnerabilityNotices";
import AINutrition from "@/components/AINutrition";

export const initializeStoryblok = storyblokInit({
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN,
  use:[apiPlugin],
  apiOptions:{
    resolve_relations: ["global_reference.reference","global_header.reference"], // Ensures full object resolution
  },
  components: {
    page: Page,
    HomePage: HomePage,
    AttackSurfaceManagementPage:AttackSurfaceManagement,
    VulnerabilityManagement: VulnerabilityManagement,
    PenetrationTesting: PenetrationTesting,
    VulnerabilityIntelligence: VulnerabilityIntelligence,
    ContinousAttackSurfaceReduction: ContinousAttackSurfaceReduction,
    NetworkApplicationVulnerabilityManagement: NetworkApplicationVulnerabilityManagement,
    VulnerabilityPrioritization: VulnerabilityPrioritization,
    NetworkInfrastructurePenetrationTesting: NetworkInfrastructurePenetrationTesting,
    MeetYourComplianceRequirements: MeetYourComplianceRequirements,
    AssetsWithKnownRansomwareExploitableVulnerabilities: AssetsWithKnownRansomwareExploitableVulnerabilities,
    AboutUs:AboutUs,
    Partner:PartnerPage,
    MediaPage: MediaPage,
    Reports:ReportsPage,
    RansomwareReport: RansomwareReport,
    CybersecurityState: CybersecurityState,
    Connect: ConnectPage,
    Careers:Careers,
    PrivacyPolicy:PrivacyPolicy,
    CustomerAgreements: CustomerAgreements,
    global_header: AppBar,
    global_reference:global_reference,
    Articles: ArticlesPage,
    Cookies:Cookies,
    Report:Report,
    ZeroDays:ZeroDays,
    "Discover Zero Days":DiscoverZeroDays,
    "Vulnerability Notices":VulnerabilityNotices,
    "AI Nutrition":AINutrition,
    "404":NotFoundPage,
    "Coming Soon" : ComingSoon,
    "Zero Days Hero":ZeroDaysHero,
    "Zero Days Table":ZeroDaysTable,
    "Zero Days Content":ZeroDaysContent,
    "Timeline Content":Timeline,
    "Zero Days Footer CTA":ZeroDaysFooterCTA,
    "Patent Body":Patent
  },
});


// Function to fetch data
export async function fetchStory(slug) {
  const storyblokApi = getStoryblokApi();
  try {
    const response = await storyblokApi.get(`cdn/stories/${slug}`, {
      version: "published", // Use 'draft' for preview mode
      cv:new Date().getTime()  
    });
    return response.data.story; // Return Storyblok data
  } catch (error) {
    console.error("Storyblok API Error:", error);
    return null;
  }
}
